export type UsagePeriod =
  | "current"
  | "previous"
  | "last_3"
  | "last_6"
  | "last_12"
  | "custom";

export const USAGE_PERIODS: Exclude<UsagePeriod, "custom">[] = [
  "current",
  "previous",
  "last_3",
  "last_6",
  "last_12",
];

export function toISODate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function parseISODate(value: string): Date {
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
}

function startOfMonth(year: number, monthIndex: number): Date {
  return new Date(year, monthIndex, 1);
}

function endOfMonth(year: number, monthIndex: number): Date {
  return new Date(year, monthIndex + 1, 0);
}

export function getPeriodRange(
  period: Exclude<UsagePeriod, "custom">,
  now = new Date()
): { created_at_after: string; created_at_before: string } {
  const year = now.getFullYear();
  const month = now.getMonth();

  if (period === "current") {
    return {
      created_at_after: toISODate(startOfMonth(year, month)),
      created_at_before: toISODate(endOfMonth(year, month)),
    };
  }

  if (period === "previous") {
    return {
      created_at_after: toISODate(startOfMonth(year, month - 1)),
      created_at_before: toISODate(endOfMonth(year, month - 1)),
    };
  }

  const monthsBack = period === "last_3" ? 2 : period === "last_6" ? 5 : 11;

  return {
    created_at_after: toISODate(startOfMonth(year, month - monthsBack)),
    created_at_before: toISODate(endOfMonth(year, month)),
  };
}

export function resolveUsageDateRange(params: Record<string, string>) {
  if (params.created_at_after && params.created_at_before) {
    return {
      created_at_after: params.created_at_after,
      created_at_before: params.created_at_before,
    };
  }

  const period = USAGE_PERIODS.includes(params.period as Exclude<UsagePeriod, "custom">)
    ? (params.period as Exclude<UsagePeriod, "custom">)
    : "current";

  return getPeriodRange(period);
}
